import script from "./dupliPopUp2.vue?vue&type=script&setup=true&lang=js"
export * from "./dupliPopUp2.vue?vue&type=script&setup=true&lang=js"

import "./dupliPopUp2.vue?vue&type=style&index=0&id=7d90792e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d90792e"]])

export default __exports__